// ScaleIQ logo — uses the transparent PNG that blends naturally on the navy background.
export default function Logo({ size = "md", showTagline = false, className = "", mark = false }) {
  const heights = { sm: "h-9", md: "h-12", lg: "h-16", xl: "h-24" };
  const h = heights[size] || heights.md;
  const src = mark ? "/assets/scaleiq-mark.png" : "/assets/scaleiq-logo.png";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src={src}
        alt="ScaleIQ — Scale Smart. Grow Fast."
        className={`${h} w-auto select-none`}
        draggable="false"
      />
      {showTagline && (
        <span className="hidden md:block overline text-ink-muted">Scale Smart. Grow Fast.</span>
      )}
    </div>
  );
}
